import {
  useEffect,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  IconButton,
  Stack,
  Text
} from '@chakra-ui/react'
import {
  ArrowIcon,
  ResizeIcon,
  ShrinkIcon
} from 'assets/icons'
import { LoadingSpinier } from 'common/Loading'
import {
  PENDING,
  REJECTED
} from 'utils/constants'
import { isNotMobile } from 'utils/helpers'
import { BlogList } from 'components/Notifications/CommunityBlogs/BlogList'
import { Comments } from 'components/Notifications/CommunityBlogs/Comments'
import { COLORS } from 'utils/styles'
import {
  getNotificationMessage,
  setBlogRepostData,
  setBlogRepostParent,
  setComments,
  setNewPostsOption,
  getComments,
  setHideNotification,
  setHideChat
} from 'store'
import { StyledMotionBox } from '../styled'

export const ContentForBlogPreview = ({
  adminNotifications,
  animateMarkerFilter,
  data,
  blogRepostData,
  blogRepostParent,
  chosenBlogIndex,
  chosenNotifBlog,
  comments,
  commentsOption,
  getCommentsStatus,
  getPostsStatus,
  postCommentsStatus,
  postsOption,
  profileItem,
  subscribeToProfileStatus,
  activeProfile,
  putCommentsStatus,
  newPostsOption
}) => {
  const dispatch = useDispatch()
  const from = 'repost-content'
  const [widenBtnClicked, setWidenBtnClicked] = useState(false)
  const [widen, setWiden] = useState(false)
  const [widenAnimation, setWidenAnimation] = useState(false)
  const [hoveringChevron, setHoveringChevron] = useState(false)

  const shouldWiden = () => widen && widenAnimation && isNotMobile()

  const getDrawerHeight = () => {
    let drawerHeight = window.innerHeight - 120

    if (postsOption.type === 'marker') {
      drawerHeight -= '26'
    }

    return drawerHeight + 'px'
  }

  const contentBlocker = () => (
    <Stack
      position="absolute"
      width="100%"
      height="100%"
      display="flex"
      zIndex={2000}
    />
  )

  const goToHeaderOriginalPos = () => {
    const panel = document.querySelector(`#blog-repost-panel-${blogRepostData.at(-1)?.id}`)
    const targetElement = panel.querySelector('#hiddenItem')

    if (targetElement) {
      setTimeout(() => {
        targetElement.scrollIntoView({ behavior: 'instant', block: 'start' })
      }, 10)
    }
  }

  const handleBlogBackBtn = () => {
    if (blogRepostParent.length > 1 && getCommentsStatus === PENDING) {
      dispatch(getNotificationMessage({
        type: REJECTED,
        message: 'Please finish loading first before returning to previous blog post or comment',
        isEditProfile: true
      }))
    } else {
      const parentData = blogRepostParent.at(-1)

      goToHeaderOriginalPos()

      dispatch(setComments([]))
      if (parentData?.parent_type) {
        dispatch(getComments({
          type: parentData.parent_type,
          ...(parentData.parent_type === 'post' ? { post_id: parentData.post_id } : { comment_id: parentData.parent_comment_id })
        }))
      }
    }

    dispatch(setBlogRepostParent(blogRepostParent.slice(0, -1)))
  }

  const chevronDirection = (type) => {
    if (postsOption.type === 'marker' && !isNotMobile()) {
      if (type === 'icon') {
        return blogRepostParent.length ? 'rotate(180deg)' : 'rotate(270deg)'
      }

      if (type === 'text') {
        return blogRepostParent.length ? 'rotate(-180deg)' : 'rotate(90deg)'
      }
    }

    if (isNotMobile() && type === 'icon') {
      return blogRepostParent.length ? 'rotate(180deg)' : 'rotate(-90deg)'
    }

    if (isNotMobile() && type === 'text') {
      return blogRepostParent.length ? 'rotate(-180deg)' : 'rotate(90deg)'
    }

    return 'rotate(180deg)'
  }

  const closeBlogPreviewDrawer = () => {
    dispatch(setBlogRepostData((blogRepostData || []).slice(0, -1)))
    dispatch(setNewPostsOption([]))
  }

  const onNarrowScreen = () => {
    const notifDrawer = document.querySelector('#NOTIFICATIONS-panel')
    const chatDrawer = document.querySelector('#chat-main-panel')

    return (notifDrawer && notifDrawer.offsetWidth * 3 < document.querySelector('body').offsetWidth)
      || (chatDrawer && chatDrawer.offsetWidth * 3 < document.querySelector('body').offsetWidth)
  }

  const checkIfOtherIsWiden = () => {
    const firstPanel = document.querySelector('#blog-panel')
    const panels = document.querySelectorAll('[id^="blog-repost-panel-"]')
    const targetWidth = window.innerWidth * 0.7
    let hasWidened = false

    if (firstPanel) {
      const computedWidth = parseFloat(window.getComputedStyle(firstPanel).width)

      if (Math.abs(computedWidth - targetWidth) < 2) {
        return true
      }
    }

    panels.forEach((el) => {
      if (!el.id.includes(data?.id)) {
        const computedWidth = parseFloat(window.getComputedStyle(el).width)

        if (Math.abs(computedWidth - targetWidth) < 2) {
          hasWidened = true
        }
      }
    })

    return hasWidened
  }

  const transition = {
    type: 'tween',
    duration: 0.8
  }

  const transition0 = {
    type: 'tween',
    duration: 0
  }

  const transitionWiden = {
    duration: 0.8,
    ease: [0.68, -0.25, 0.265, 1.25]
  }

  const animateVariants = {
    WideScreen: {
      initial: {
        width: '368px',
        height: '0px',
        paddingBottom: '20px',
        ...(postsOption.type === 'marker' ? { bottom: '24px' } : {})
      },
      animate: {
        width: shouldWiden() && widenAnimation ? Math.round(window.innerWidth * 0.7) : '368px',
        height: `calc(${getDrawerHeight()} - env(safe-area-inset-top))`,
        paddingBottom: '0px',
        transition: widenBtnClicked ? transitionWiden : transition
      },
      exit: {
        padding: '0px',
        width: '368px',
        height: '0px',
        transition
      },
      exit0: {
        padding: '0px',
        width: '368px',
        height: '0px',
        transition: transition0
      }
    },
    NarrowScreen: {
      initial: {
        width: '95.3%',
        height: `calc(${getDrawerHeight()} - env(safe-area-inset-top))`,
        marginRight: '10px',
        x: 450
      },
      animate: {
        x: 0,
        transition
      },
      exit: {
        x: 450,
        marginRight: '-450px',
        transition
      },
      exit0: {
        x: 450,
        marginRight: '-450px',
        transition: transition0
      }
    },
    NarrowScreenMarker: {
      initial: {
        width: document.querySelector('#marker-popup-container')?.offsetWidth + 3 + 'px' ?? '366px',
        height: '0px',
        bottom: '29px'
      },
      animate: {
        height: `calc(${getDrawerHeight()} - env(safe-area-inset-top))`,
        transition
      },
      exit: {
        height: '0px',
        transition
      },
      exit0: {
        height: '0px',
        transition: transition0
      }
    }
  }

  const handleAnimationVariants = () => {
    if (postsOption.type === 'marker' && !isNotMobile()) {
      return animateVariants.NarrowScreenMarker
    }

    return animateVariants[isNotMobile() ? 'WideScreen' : 'NarrowScreen']
  }

  useEffect(() => {
    setHoveringChevron(false)
  }, [])

  return (
    <StyledMotionBox
      id={`blog-repost-panel-${data?.id}`}
      key={`blog-repost-panel-${data?.id}`}
      variants={handleAnimationVariants()}
      initial="initial"
      animate="animate"
      exit={blogRepostData?.at(-1)?.id === data.id ? 'exit' : 'exit0'}
      onAnimationComplete={() => setWidenBtnClicked(false)}
      style={{
        translateX: '-50%',
        transformOrigin: 'bottom center',
        clipPath: 'inset(0)'
      }}
      overflowY={blogRepostData?.at(-1)?.id === data.id ? 'auto' : 'hidden'}
      filter={blogRepostData?.at(-1)?.id === data.id ? '' : 'blur(2px)'}
      zIndex={postsOption?.type === 'marker' ? 1404 : 1409}
    >
      <Stack
        alignItems="center"
        justifyContent="space-between"
        direction="row"
        p="0px 5px"
        background={COLORS.goldGradientRightToLeft}
        minHeight="48px"
        borderRadius="10px 10px 0 0"
        marginTop="-1px"
        position="sticky"
        top="-0.2"
        zIndex={1050}
      >
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            setWidenAnimation(true)
            setWidenBtnClicked(true)
            setWiden(true)

            if (isNotMobile()) {
              dispatch(setHideNotification(true))
              dispatch(setHideChat(true))
            }

            if (postsOption.type !== 'marker') {
              animateMarkerFilter(false)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          icon={<ResizeIcon />}
          id="resize-button"
          outline="none"
          boxShadow="none"
          display={widen ? 'none' : 'flex'}
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            setWidenAnimation(true)
            setWidenBtnClicked(true)
            setWiden(false)

            if (
              onNarrowScreen()
              && !checkIfOtherIsWiden()
              && isNotMobile()
            ) {
              dispatch(setHideNotification(false))
              dispatch(setHideChat(false))
            }

            if (
              onNarrowScreen()
              && postsOption.type !== 'marker'
              && !checkIfOtherIsWiden()
            ) {
              animateMarkerFilter(true)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          icon={<ShrinkIcon />}
          id="shrink-button"
          outline="none"
          boxShadow="none"
          display={widen ? 'auto' : 'none'}
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />

        <Text
          maxWidth="70%"
          fontSize="24px"
          textAlign="center"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
        >
          { data?.full_name + "'s Blog" }
        </Text>

        <IconButton
          onClick={() => {
            if (blogRepostParent.length) {
              handleBlogBackBtn()
            } else {
              if (
                onNarrowScreen()
                && !checkIfOtherIsWiden()
                && isNotMobile()
              ) {
                dispatch(setHideNotification(false))
                dispatch(setHideChat(false))
              }

              if (
                onNarrowScreen()
                && postsOption.type !== 'marker'
                && !checkIfOtherIsWiden()
              ) {
                animateMarkerFilter(true)
              }

              closeBlogPreviewDrawer()
            }

            setHoveringChevron(false)
          }}
          onPointerEnter={(e) => {
            if (e.pointerType === 'mouse') {
              setHoveringChevron(true)
            }
          }}
          onPointerLeave={(e) => {
            if (e.pointerType === 'mouse') {
              setHoveringChevron(false)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          transform={chevronDirection('icon')}
          transition="none"
          icon={(
            <>
              <Text
                fontWeight="300"
                transform={chevronDirection('text')}
                display={hoveringChevron ? 'flex' : 'none'}
              >
                {blogRepostParent.length ? 'Back' : 'Exit'}
              </Text>

              <Stack display={hoveringChevron ? 'none' : 'flex'}>
                <ArrowIcon height="15px" />
              </Stack>
            </>
          )}
          id="blog-modal-back-button"
          outline="none"
          boxShadow="none"
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />
      </Stack>

      {
        blogRepostData?.at(-1)?.id === data.id
          ? ''
          : contentBlocker()
      }

      <Stack position="relative">
        {
          blogRepostData?.at(-1)?.id === data.id
            ? ''
            : contentBlocker()
        }

        {
          getPostsStatus === PENDING
          && blogRepostData?.at(-1)?.id === data.id
            ? (
              <Stack marginTop="100px">
                <LoadingSpinier />
              </Stack>
            )
            : (
              <BlogList
                from={from}
                activeProfile={activeProfile}
                blogParent={blogRepostParent}
                chosenBlogIndex={chosenBlogIndex}
                getPostsStatus={getPostsStatus}
                posts={[data]}
                blogRepostData={blogRepostData}
                blogRepostParent={blogRepostParent}
                postsOption={postsOption}
                profileItem={profileItem}
                chosenNotifBlog={chosenNotifBlog}
                subscribeToProfileStatus={subscribeToProfileStatus}
                adminNotifications={adminNotifications}
                widen={widen}
                setWiden={setWiden}
                newPostsOption={newPostsOption}
                CommentSection={(
                  <Comments
                    activeProfile={activeProfile}
                    blogParent={blogRepostParent}
                    blogRepostData={blogRepostData}
                    comments={comments}
                    commentsOption={commentsOption}
                    getCommentsStatus={getCommentsStatus}
                    postCommentsStatus={postCommentsStatus}
                    putCommentsStatus={putCommentsStatus}
                    widen={widen}
                  />
                )}
              />
            )
        }
      </Stack>
    </StyledMotionBox>
  )
}
